import type { Rule } from 'antd/es/form';

import { hasNonAsciiChar, isValidEmail } from 'app/utils/email';

export const requiredRule: Rule = {
  required: true,
  message: 'This field is required',
};

export const emailAsciiRule: Rule = {
  validator: (_, value?: string) =>
    hasNonAsciiChar(value)
      ? Promise.reject(
          new Error('Email must not contain accented or special characters')
        )
      : Promise.resolve(),
};

export const emailFormatRule: Rule = {
  validator: (_, value?: string) =>
    !value || isValidEmail(value)
      ? Promise.resolve()
      : Promise.reject(new Error('Please enter a valid email address')),
};

export const eInvoicingIdNotEmailRule: Rule = {
  validator: (_, value?: string) =>
    isValidEmail(value?.trim())
      ? Promise.reject(
          new Error(
            'Enter a routing code (e.g. SIREN_SIRET_CodeDeRoutage). Email addresses are not accepted.'
          )
        )
      : Promise.resolve(),
};

export const maxCharactersRule = (maxCharacters: number): Rule => {
  return {
    max: maxCharacters,
    message: `Max ${maxCharacters} characters`,
  };
};
